import useSWR from 'swr';
import { CONSTANTS } from '@/constants';
import { request } from '@/utils/request';

interface NeedVerifyResponse {
  success: boolean;
  message: string;
  code: string;
  innerMessage: string | null;
  data: boolean;
}

async function fetchNeedVerify({ address }: { address: string }) {
  if (!address) {
    return undefined;
  }
  // data: true => thi phai di verification
  const response = await request(
    `${CONSTANTS.BASE_URL}/api/world-coin-chest-smasher/need-verification?wallet=${address}`,
  );

  if (!response.ok) {
    throw new Error('Failed to fetch need verification status');
  }

  return response.json();
}

export function useNeedVerify(address: string) {
  const data = useSWR<NeedVerifyResponse>(
    { key: 'fetchNeedVerify', address },
    fetchNeedVerify,
    {
      revalidateOnFocus: false,
      refreshInterval: 0,
      dedupingInterval: 60000,
    },
  );

  return data;
}
